import React from 'react';
import './DashboardOverview.css';

function DashboardOverview({ apiBase, stats, onRefresh }) {
  return (
    <div className="dashboard-overview">
      <div className="overview-header">
        <h2>Dashboard Overview</h2>
        <button className="btn-refresh" onClick={onRefresh} title="Refresh data">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 4 23 10 17 10"></polyline>
            <polyline points="1 20 1 14 7 14"></polyline>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36M20.49 15a9 9 0 0 1-14.85 3.36"></path>
          </svg>
        </button>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#d1fae5' }}>
            <svg viewBox="0 0 24 24" fill="currentColor" color="#10b981">
              <path d="M9 12h6m-6 4h6m2-15H7a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2V3a2 2 0 00-2-2z" />
            </svg>
          </div>
          <div className="stat-content">
            <p className="stat-label">Total Konten</p>
            <p className="stat-value">{stats.totalContent}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#fef3c7' }}>
            <svg viewBox="0 0 24 24" fill="currentColor" color="#f59e0b">
              <path d="M9 12h6m-6 4h6m2-15H7a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2V3a2 2 0 00-2-2z" />
            </svg>
          </div>
          <div className="stat-content">
            <p className="stat-label">Draft</p>
            <p className="stat-value">{stats.draftContent}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#dbeafe' }}>
            <svg viewBox="0 0 24 24" fill="currentColor" color="#0284c7">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="stat-content">
            <p className="stat-label">Menunggu Approval</p>
            <p className="stat-value" style={{ color: '#0284c7' }}>{stats.pendingApproval}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#d1fae5' }}>
            <svg viewBox="0 0 24 24" fill="currentColor" color="#10b981">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="stat-content">
            <p className="stat-label">Published</p>
            <p className="stat-value">{stats.publishedContent}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#fce7f3' }}>
            <svg viewBox="0 0 24 24" fill="currentColor" color="#ec4899">
              <path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>
          </div>
          <div className="stat-content">
            <p className="stat-label">Testimonial Pending</p>
            <p className="stat-value">{stats.pendingTestimonials}</p>
          </div>
        </div>
      </div>

      <div className="overview-actions">
        <h3>Quick Actions</h3>
        <div className="actions-grid">
          <button className="action-btn">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 5v14M5 12h14" />
            </svg>
            Buat Konten Baru
          </button>
          <button className="action-btn">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            Lihat Approval
          </button>
          <button className="action-btn">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
            </svg>
            Review Testimonial
          </button>
        </div>
      </div>
    </div>
  );
}

export default DashboardOverview;
